import { ExamReportType } from '../../api/exam-report';
import { BLANK_TEXT } from '../../utils';

export type MainExamReportsPropsType = {
  examReport: ExamReportType;
};

function MainExamReport({ examReport }: MainExamReportsPropsType) {
  return (
    <div className='my-2 mx-auto w-full max-w-5xl'>
      <p className='my-6 text-center font-bold'>کارنامه کلی در یک نگاه</p>
      <table className='mx-auto w-full table-auto'>
        <thead>
          <tr className='bg-sky-100 text-center'>
            <th className='border border-zinc-800 p-0.5 font-medium text-green-600 xs:p-1 xs:text-xl'>
              <span className='hidden xs:inline'>صحیح</span>
              <span className='xs:hidden'>ص</span>
            </th>
            <th className='border border-zinc-800 p-0.5 font-medium text-yellow-600 xs:p-1 xs:text-xl'>
              <span className='hidden xs:inline'>نزده</span>
              <span className='xs:hidden'>ن</span>
            </th>
            <th className='border border-zinc-800 p-0.5 font-medium text-red-600 xs:p-1 xs:text-xl'>
              <span className='hidden xs:inline'>غلط</span>
              <span className='xs:hidden'>غ</span>
            </th>
            {['درصد', 'تراز', 'رتبه'].map(header => (
              <th key={header} className='border border-zinc-800 p-0.5 font-medium xs:p-1'>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className='border border-zinc-800 text-center'>
              {examReport.correctQuestionCount}
            </td>
            <td className='border border-zinc-800 text-center'>
              {examReport.questionCount -
                examReport.correctQuestionCount -
                examReport.wrongQuestionCount}
            </td>
            <td className='border border-zinc-800 text-center'>{examReport.wrongQuestionCount}</td>
            <td dir='ltr' className='border border-zinc-800 text-center'>
              <span>{examReport.score}</span>
              <span className='hidden xs:inline'>%</span>
            </td>
            <td className='border border-zinc-800 text-center'>
              {examReport.scaledScore || BLANK_TEXT}
            </td>
            <td className='border border-zinc-800 text-center'>{examReport.rank || BLANK_TEXT}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default MainExamReport;
